module.exports = __webpack_public_path__ + "static/img/live-moment-bg.797585ac.png";